import React from 'react';

export const DocumentCandidateSearch = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="
http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 2H4.5C4.2 2 4 2.2 4 2.5V21.5C4 21.8 4.2 22 4.5 22H12.5C12.8 22 13 21.8 13 21.5V20.5C13 20.2 12.8 20 12.5 20H6V4H18V12.5C18 12.8 18.2 13 18.5 13H19.5C19.8 13 20 12.8 20 12.5V2.5C20 2.2 19.8 2 19.5 2ZM20.5 20.4L19.6 19.5C19.8 19.1 20 18.6 20 18C20 16.3 18.7 15 17 15C15.3 15 14 16.3 14 18C14 19.7 15.3 21 17 21C17.5 21 18.1 20.9 18.5 20.6L19.4 21.5C19.6 21.7 19.9 21.7 20.1 21.5L20.5 21.1C20.7 20.9 20.7 20.6 20.5 20.4ZM18.5 18C18.5 18.8 17.8 19.5 17 19.5C16.2 19.5 15.5 18.8 15.5 18C15.5 17.2 16.2 16.5 17 16.5C17.8 16.5 18.5 17.2 18.5 18ZM8.5 16C8.2 16 8 16.2 8 16.5V17.5C8 17.8 8.2 18 8.5 18H11.5C11.8 18 12 17.8 12 17.5V16.5C12 16.2 11.8 16 11.5 16H8.5ZM8.5 13C8.2 13 8 13.2 8 13.5V14.5C8 14.8 8.2 15 8.5 15H13.5C13.8 15 14 14.8 14 14.5V13.5C14 13.2 13.8 13 13.5 13H8.5ZM10.5 6C9.7 6 9 6.7 9 7.5C9 8.3 9.7 9 10.5 9H9.5C8.7 9 8 9.7 8 10.5V12H13V10.5C13 9.7 12.3 9 11.5 9H10.5C11.3 9 12 8.3 12 7.5C12 6.7 11.3 6 10.5 6Z"
      fill="#444D55"
    />
  </svg>
);
